import * as React from 'react';

import { Banner, BannerProps } from '@built/design-system';
import { ReactComponent as DangerIcon } from '@built/design-system/icons/action/announcement.svg';
import { ReactComponent as WarningIcon } from '@built/design-system/icons/alert/warning.svg';
import { ReactComponent as SuccessIcon } from '@built/design-system/icons/action/check_circle.svg';
import { ReactComponent as InfoIcon } from '@built/design-system/icons/navigation/chevron_right.svg';

import * as styles from './Notification.module.scss';

/**
 * Displays a simple notification that presents the user with information
 * and can be styled depending on the tone of the notification.
 */
export default function Notification(props: NotificationProps) {
  const { type = 'warning', content } = props;
  const className =
    type === 'success'
      ? styles.success
      : type === 'warning'
      ? styles.warning
      : undefined;
  const media =
    type === 'danger' ? (
      <DangerIcon width={24} height={24} className={styles.danger} />
    ) : type === 'warning' ? (
      <WarningIcon width={24} height={24} className={styles.warning} />
    ) : type === 'info' ? (
      <InfoIcon width={24} height={24} className={styles.info} />
    ) : (
      <SuccessIcon width={24} height={24} className={styles.success} />
    );

  const classes = [className];
  if (props.className) {
    classes.push(props.className);
  }

  return (
    <Banner {...props} className={classes.join(' ')} media={media} type={type}>
      {content}
    </Banner>
  );
}

export interface NotificationProps extends BannerProps {
  /** Content to display in the notification */
  content: string | React.ReactNode;
}
